import { render } from "./galeria.vue?vue&type=template&id=683c5c1b&scoped=true"
import script from "./galeria.vue?vue&type=script&lang=js"
export * from "./galeria.vue?vue&type=script&lang=js"

import "./galeria.vue?vue&type=style&index=0&id=683c5c1b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-683c5c1b"]])

export default __exports__